import { CLAIMS } from "../../../../constants";

export const data = [
    {
        title: "Заявки по рабочему времени и отпускам",
        description: "Заявки на отпуск, изменение рабочего времени и графика работы",
        path: "/main/hr-services/work-time/requests",
        // path: "#",
        // secured: true,
    },
    {
        title: "Заявки на увольнение",
        description: "Заявка на увольнение по собственному желанию, отзыв увольнения",
        // path: "#",
        path: "/main/hr-services/layoff/request",
        // secured: true,
        // unep: true,
    },
    {
        title: "Заявки руководителя",
        description: "Отпуска, ОВЗ, служебные записки и другие",
        // icon: blank,
        claims: CLAIMS.LINE_MANAGER,
        path: "/main/hr-services/requests/leader",
        leadersBlock: true,
    },

];
